<template>
  <div>
    <b-card no-body>
      <b-card-body class="p-4">
        <h1>Registration Successful</h1>
        <p class="text-muted mt-3">You have successfully created an account. Please click the button below to login and start using the system.</p>
        <b-button variant="success" block @click="toLogin">Go to login</b-button>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
export default {
  name: 'RegisterSuccess',
  data() {
    return {}
  },
  methods: {
    toLogin: function() {
      this.$router.push('/login');
    }
  }
}
</script>
